import { useTranslation } from "react-i18next";
import { useTime } from "utils";

import {
  type AthleteProduct,
  getAthleteProductStatusLabel,
} from "src/helpers/athleteProductState";

import { AthleteProductBadge } from "./AthleteProductBadge";

interface AthleteProductHiddenRowProps {
  product: AthleteProduct;
}

export function AthleteProductHiddenRow(props: AthleteProductHiddenRowProps) {
  const { t } = useTranslation();
  const time = useTime();

  return (
    <div className="flex items-center gap-2">
      <AthleteProductBadge product={props.product} />
      <span>{getAthleteProductStatusLabel(t, time, props.product)}</span>
    </div>
  );
}
